import type { InjectionKey, Slots } from 'vue'
export interface TabRecord { id: symbol; title: Slots['title']; titleLinkClass: unknown }
export interface TabsContext {
  activeIndex: () => number
  indexOf: (id: symbol) => number
  register: (tab: TabRecord) => void
  update: (id: symbol, tab: Omit<TabRecord, 'id'>) => void
  unregister: (id: symbol) => void
}
export const tabsContextKey: InjectionKey<TabsContext> = Symbol('tabs')
